import type React from 'react';

import { Box, FormField, FormHelp, Label } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';
import { RENTERS_INSURANCE } from '../../../constants';
import CurrencyInput from '../../Widgets/CurrencyInput';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const INITIAL_STATE = {
  [RENTERS_INSURANCE.FIELD_NAME.IS_ENABLED]: false,
  [RENTERS_INSURANCE.FIELD_NAME.MINIMUM_COVERAGE]: '',
};

export default function RentersInsurance({ section, setSectionValues }: Props): JSX.Element {
  function onNoRequireRentersInsurance(): void {
    setSectionValues(INITIAL_STATE);
  }

  function onYesRequireRentersInsurance(): void {
    setSectionValues({
      [RENTERS_INSURANCE.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onMinimumCoverageChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({ [RENTERS_INSURANCE.FIELD_NAME.MINIMUM_COVERAGE]: value });
  }

  return (
    <>
      <FormField
        required
        label={<Label>Will you require tenants to obtain renters insurance?</Label>}
        description={
          <FormHelp>
            In the lease, renters insurance means insurance that covers tenant’s personal property and damage to the
            property
          </FormHelp>
        }
        control={
          <YesAndNoExpansion
            yesHandler={onYesRequireRentersInsurance}
            noHandler={onNoRequireRentersInsurance}
            yesActive={section.getFieldValue(RENTERS_INSURANCE.FIELD_NAME.IS_ENABLED)}
          >
            <Box css={{ marginTop: 'layout.tight' }} />
            <FormField
              required
              label={<Label id="min-coverage-amt">Minimum coverage amount</Label>}
              control={
                <CurrencyInput
                  aria-labelledby="min-coverage-amt"
                  data-test="min-coverage-amt"
                  value={section.getFieldValue(RENTERS_INSURANCE.FIELD_NAME.MINIMUM_COVERAGE)}
                  onChange={onMinimumCoverageChange}
                  onBlur={onMinimumCoverageChange}
                />
              }
              description={
                <FormHelp>An insurance broker can help you determine an appropriate amount of coverage</FormHelp>
              }
            />
          </YesAndNoExpansion>
        }
      />
    </>
  );
}
